import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function BriefcaseIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.6667 5.83301H3.33341c-.92047 0-1.66666.74619-1.66666 1.66666V15.833c0 .9205.74619 1.6667 1.66666 1.6667H16.6667c.9205 0 1.6667-.7462 1.6667-1.6667V7.49967c0-.92047-.7462-1.66666-1.6667-1.66666Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 17.5V4.16667c0-.44203-.1756-.86595-.4881-1.17851-.3126-.31257-.7365-.48816-1.1786-.48816H8.33341c-.44202 0-.86595.17559-1.17851.48816-.31256.31256-.48815.73648-.48815 1.17851V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
